import script from "./NumberInputWithControls.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInputWithControls.vue?vue&type=script&setup=true&lang=js"

import "./NumberInputWithControls.vue?vue&type=style&index=0&id=5741a9c6&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QField});
